import script from "./Table.vue?vue&type=script&setup=true&lang=ts"
export * from "./Table.vue?vue&type=script&setup=true&lang=ts"

import "./Table.vue?vue&type=style&index=0&id=d0646c86&scoped=true&lang=css"

import exportComponent from "/home/runner/work/onino-app/onino-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0646c86"]])

export default __exports__